import { render, staticRenderFns } from "./RiskBreakdownChart.vue?vue&type=template&id=46869846&scoped=true&"
import script from "./RiskBreakdownChart.vue?vue&type=script&lang=ts&"
export * from "./RiskBreakdownChart.vue?vue&type=script&lang=ts&"
import style0 from "./RiskBreakdownChart.vue?vue&type=style&index=0&id=46869846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46869846",
  null
  
)

export default component.exports